import ServiceField from "./ServiceField";
import ServiceDatePicker from "./ServiceDatePicker";
import NextServiceMileageField from "./NextServiceMileageField";

/**
 * Shared service form fields — single source of truth for the
 * LatestServices edit popup AND the Periodic registration page.
 *
 * - Mileage / cost: Persian display + 3-digit separators handled by the
 *   parent via `toPersianNumericDisplay`; parsed back with `parsePersianNumber`.
 * - Date: Jalali UI (ServiceDatePicker), Gregorian ISO value for the backend.
 * - All fields are full-width + RTL through `.ls-pop__field` / `.ls-date`
 *   styles in LatestServices.scss (Periodic imports the same stylesheet).
 */
function ServiceFormFields({
  mileage,
  onMileageChange,
  dateISO,
  onDateChange,
  cost,
  onCostChange,
  mechanic,
  onMechanicChange,
  description,
  onDescriptionChange,
  mileageLabel = "کیلومتر",
  mileagePlaceholder = "کیلومتر",
  // Optional Next Service Mileage — rendered directly below the mileage
  // field when the parent passes `nextMileage` (Periodic registration).
  // Same formatting/display contract as the mileage field.
  nextMileage,
  onNextMileageChange,
  nextMileageLabel = "کیلومتر سرویس بعدی",
  nextMileagePlaceholder = "کیلومتر سرویس بعدی",
  dateLabel = "تاریخ سرویس (شمسی)",
  datePlaceholder = "تاریخ را انتخاب کنید",
  costLabel = "هزینه (تومان)",
  costPlaceholder = "اختیاری",
  showCost = true,
  mechanicLabel = "مکانیک",
  mechanicPlaceholder = "نام مکانیک (اختیاری)",
  descriptionLabel = "توضیحات",
  descriptionPlaceholder = "توضیحات (اختیاری)",
  disabled = false,
}) {
  return (
    <>
      <ServiceField
        label={mileageLabel}
        type="text"
        inputMode="numeric"
        value={mileage}
        onChange={onMileageChange}
        placeholder={mileagePlaceholder}
        disabled={disabled}
      />
      {onNextMileageChange && (
        <NextServiceMileageField
          value={nextMileage ?? ""}
          onChange={onNextMileageChange}
          label={nextMileageLabel}
          placeholder={nextMileagePlaceholder}
          disabled={disabled}
        />
      )}
      <ServiceDatePicker
        value={dateISO}
        onChange={onDateChange}
        label={dateLabel}
        placeholder={datePlaceholder}
        disabled={disabled}
      />
      {showCost && <ServiceField
        label={costLabel}
        type="text"
        inputMode="numeric"
        value={cost}
        onChange={onCostChange}
        placeholder={costPlaceholder}
        disabled={disabled}
      />}
      <ServiceField
        label={mechanicLabel}
        type="text"
        value={mechanic}
        onChange={onMechanicChange}
        placeholder={mechanicPlaceholder}
        maxLength={120}
        disabled={disabled}
      />
      <ServiceField
        label={descriptionLabel}
        type="text"
        value={description}
        onChange={onDescriptionChange}
        placeholder={descriptionPlaceholder}
        maxLength={500}
        disabled={disabled}
      />
    </>
  );
}

export default ServiceFormFields;
